import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu } from 'semantic-ui-react'

import { markBillingInvoicePaid, unmarkBillingInvoicePaid } from 'actions/billing'

const today = () => new Date().toISOString().slice(0, 10)

class TogglePaidBillingInvoiceItem extends React.Component {
  handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { billingInvoice } = this.props
    if (billingInvoice.payedAt) {
      this.props.unmarkPaid(billingInvoice.id)
    } else {
      const date = window.prompt('Paid on (YYYY-MM-DD):', today())
      if (date) this.props.markPaid(billingInvoice.id, date)
    }
  }

  render () {
    const { billingInvoice } = this.props
    if (!['issued', 'reminded', 'paid'].includes(billingInvoice.status)) return null

    return (
      <Menu.Item onClick={this.handleClick} title={billingInvoice.payedAt ? 'Unmark paid' : 'Mark paid'}>
        <Icon.Group size="large">
          <Icon name="euro"/>
          {billingInvoice.payedAt && <Icon corner name="check circle" color="green"/>}
        </Icon.Group>
      </Menu.Item>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  markPaid: (id, date) => dispatch(markBillingInvoicePaid(id, date)),
  unmarkPaid: (id) => dispatch(unmarkBillingInvoicePaid(id))
})

export default connect(null, mapDispatchToProps)(TogglePaidBillingInvoiceItem)
